module.exports = __webpack_public_path__ + "img/right-arrow-hover.14f5a231.svg";